import React from "react";
import { Alert, Col, Container, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";
import QRCode from "react-qr-code";
import Switch from "react-switch";

class CreateScriptDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      email: {
        defaultValue: "",
        initValid: false,
        rule: ValidationHelper.isEmail,
      },
      role: {
        defaultValue: undefined,
        initValid: false,
        rule: (value) =>
          ValidationHelper.isIntInRange(value, 0, 3) && value !== 2,
      },
      hasInternalLogin: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean,
      },
      password: {
        defaultValue: "",
        initValid: true,
        rule: (value) =>
          ValidationHelper.isPassword(value) || value.length === 0,
      },
      passwordConfirm: {
        defaultValue: "",
        initValid: true,
        rule: (value) =>
          this.state.validation.password &&
          value === this.state.validation.password.value,
      },
      hasMFA: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean,
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      mfaKeyUri: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      const createdUser = await this.props.onSubmit(validatedData);
      if (createdUser && typeof createdUser["mfaKeyUri"] !== "undefined") {
        this.setState({ mfaKeyUri: createdUser["mfaKeyUri"] });
      }
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition),
        mfaKeyUri: null,
      });
    }
  }

  onHide() {
    if (this.state.mfaKeyUri) {
      this.props.onHide(false);
    } else {
      this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
    }
  }

  render() {
    const { t } = this.props;

    const roles = [
      { label: t("Users.Roles.Lecturer"), value: 0 },
      { label: t("Users.Roles.Administrator"), value: 1 },
      { label: t("Users.Roles.Auditor"), value: 3 }
    ];

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        title={t("Users.CreateModal.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonCallback={this.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        rightButtonCallback={this.onSubmit}
        rightButtonText={t("Users.CreateModal.Form.Submit")}
        rightButtonVariant="green"
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form onSubmit={this.onSubmit}>
            {this.state.mfaKeyUri ? (
              <>
                <Alert variant="success">
                  {t("Users.CreateModal.UpdateSuccessful")}
                </Alert>
                <Alert variant="info">
                  <Container>
                    <Row>
                      <Col>
                        <p>{t("Users.CreateModal.Authenticator")}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={9}>
                        <ul>
                          <li>Microsoft Authenticator</li>
                          <li>Google Authenticator</li>
                        </ul>
                      </Col>
                      <Col className="align-middle floatRight">
                        <div className="floatRight">
                          <QRCode
                            value={this.state.mfaKeyUri}
                            level="M"
                            size={100}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Alert>
              </>
            ) : (
              ""
            )}
            <Form.Group controlId="formEmail">
              <Form.Label>{t("Users.CreateModal.Form.Email")}</Form.Label>
              <Form.Control
                type="text"
                name="email"
                placeholder={t("Users.CreateModal.Form.EmailPlaceholder")}
                value={this.state.validation.email.value}
                isInvalid={!this.state.validation.email.isValid}
                onChange={this.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {t("Users.CreateModal.Form.ValidationError.Email")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formRole">
              <Form.Label>{t("Users.CreateModal.Form.Role")}</Form.Label>
              <BaseSelect
                options={roles}
                menuPosition="fixed"
                id="formRole"
                placeholder={t("Users.CreateModal.Form.RolePlaceholder")}
                onChange={(value) => {
                  this.handleChange({
                    target: {
                      name: "role",
                      value: value.value,
                    },
                  });
                }}
              />
              <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.role.isValid}
              />
              <Form.Control.Feedback type="invalid">
                {t("Users.CreateModal.Form.ValidationError.Role")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formInternalLogin" className="mt-2">
              <hr />
              <Form.Label>
                {t("Users.CreateModal.Form.InternalLogin")}{" "}
              </Form.Label>
              <Switch
                className="float-right"
                onColor="#54BF8D"
                checked={this.state.validation.hasInternalLogin.value}
                onChange={(state) => {
                  this.handleChange({
                    target: {
                      name: "hasInternalLogin",
                      value: state,
                    },
                  });
                }}
                height={18}
                width={40}
              />
              <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.hasInternalLogin.isValid}
              />
            </Form.Group>
            {this.state.validation.hasInternalLogin &&
            this.state.validation.hasInternalLogin.value ? (
              <>
                <Form.Group controlId="formPassword">
                  <Form.Label>
                    {t("Users.CreateModal.Form.Password")}
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={this.state.validation.password.value}
                    isInvalid={!this.state.validation.password.isValid}
                    onChange={this.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Users.CreateModal.Form.ValidationError.Password")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formPasswordConfirm">
                  <Form.Label>
                    {t("Users.CreateModal.Form.PasswordConfirm")}
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="passwordConfirm"
                    value={this.state.validation.passwordConfirm.value}
                    isInvalid={!this.state.validation.passwordConfirm.isValid}
                    onChange={this.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(
                      "Users.CreateModal.Form.ValidationError.PasswordConfirm",
                    )}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formHasMFA" className="mt-2">
                  <hr />
                  <Form.Label>{t("Users.CreateModal.Form.HasMFA")} </Form.Label>
                  <Switch
                    className="float-right"
                    onColor="#54BF8D"
                    checked={this.state.validation.hasMFA.value}
                    onChange={(state) => {
                      this.handleChange({
                        target: {
                          name: "hasMFA",
                          value: state,
                        },
                      });
                    }}
                    height={18}
                    width={40}
                  />
                  <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.hasMFA.isValid}
                  />
                </Form.Group>
                <ul>
                  <li>Microsoft Authenticator</li>
                  <li>Google Authenticator</li>
                </ul>
              </>
            ) : (
              ""
            )}
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(CreateScriptDialog);
